import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const vendor = data => {
  return httpClient
    .get('/api/v1/reports/finances/vendors', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const payToVendor = data => {
  return httpClient
    .post('/api/v1/reports/finances/pay-to-vendors', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const payToVendorExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/pay-to-vendors/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const incomeStatementDetail = data => {
  return httpClient
    .post('/api/v1/reports/finances/income-statment-details', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const incomeStatementDetailExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/income-statment-details/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const grossProfit = data => {
  return httpClient
    .post('/api/v1/reports/finances/gross-profit', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const grossProfitExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/gross-profit/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const saleByCustomerSummary = data => {
  return httpClient
    .post('/api/v1/reports/finances/sale-by-customers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const saleByCustomerSummaryToExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/sale-by-customer-to-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const customerProfile = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/customers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const accountReceivable = data => {
  return httpClient
    .get('/api/v1/reports/finances/account-receivables', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const accountReceivableExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/account-receivables/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const cashCollectionByCashier = data => {
  return httpClient
    .get('/api/v1/reports/finances/cash-collection-cashiers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const cashCollectionByCashierExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/cash-collection-cashiers/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const yearlySoldBySaleType = data => {
  return httpClient
    .get('/api/v1/reports/finances/yearly-sold-by-sale-types', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const yearlySoldBySaleTypeExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/yearly-sold-by-sale-types/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const customerSalesByMonth = data => {
  return httpClient
    .get('/api/v1/reports/finances/customer_sales_by_months', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const customerSalesByMonthExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/customer_sales_by_months/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const grossProfitCustomerExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/gross-profit-customer/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const grossProfitCustomer = data => {
  return httpClient
    .post('/api/v1/reports/finances/gross-profit-customers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productCategory = () => {
  return httpClient
    .get('/api/v1/reports/product-categories')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productGroup = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/product-groups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productProfileLocation = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/product-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getBranch = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/branches', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const customerType = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/customer-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const saleContractExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/sale-contracts/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const saleContract = data => {
  return httpClient
    .post('/api/v1/reports/finances/sale-contracts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const accountPayable = data => {
  return httpClient
    .post('/api/v1/reports/finances/account-payables', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const accountPayableExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/account-payables/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const cashCollectionRestaurantSaleByCashier = data => {
  return httpClient
    .get('/api/v1/reports/finances/cash-collection-restaurant-sales', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const cashCollectionRestaurantSaleByCashierExcel = data => {
  return httpClient
    .post(
      '/api/v1/reports/finances/cash-collection-restaurant-sales/excels',
      data,
      {
        responseType: 'arraybuffer'
      }
    )
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlyReportSummary = data => {
  return httpClient
    .get('/api/v1/reports/finances/monthly-report-summarys', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlySummarySaleReportExportExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/summary-sale-report-export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.resolve(error.response.data))
}
export const getCashier = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/cashier', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  payToVendor,
  vendor,
  incomeStatementDetail,
  grossProfit,
  saleByCustomerSummary,
  saleByCustomerSummaryToExcel,
  customerProfile,
  accountReceivable,
  payToVendorExcel,
  incomeStatementDetailExcel,
  grossProfitExcel,
  accountReceivableExcel,
  cashCollectionByCashier,
  cashCollectionByCashierExcel,
  yearlySoldBySaleType,
  yearlySoldBySaleTypeExcel,
  customerSalesByMonth,
  customerSalesByMonthExcel,
  grossProfitCustomerExcel,
  productCategory,
  productGroup,
  productProfileLocation,
  getBranch,
  customerType,
  grossProfitCustomer,
  saleContract,
  saleContractExcel,
  accountPayable,
  accountPayableExcel,
  cashCollectionRestaurantSaleByCashier,
  cashCollectionRestaurantSaleByCashierExcel,
  monthlyReportSummary,
  get,
  monthlySummarySaleReportExportExcel,
  getCashier
}
